exports.saveAcivity = (path, title) => {
  if (window.gtag) {
    console.log(path, title);
    window.gtag('config', 'G-Q2N4NPCFR4', {
      page_path: path,
      page_view: 'pv' + path,
      page_title: title
    });

    //following is for Hiran for google ads
    window.gtag('config', 'AW-10894574975', {
      page_path: path,
      page_view: 'pv' + path,
      page_title: title
    });
  }
}


exports.recaptcha = (action = 'signup') => {
  return new Promise((resolve) => {
    window.grecaptcha.ready(function () {
      window.grecaptcha.execute('6LfOl7AZAAAAABw6URm9_zSDNH3QD6reGCLOLlHP', {action: action}).then(function (token) {
        // Add your logic to submit to your backend server here.
        console.log(token);
        resolve(token);
      });
    });
  });
}
